export default __webpack_public_path__ + "static/media/square.52ecb3d6.svg";